import * as tslib_1 from "tslib";
import { TranslateService } from '@ngx-translate/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { chain } from 'lodash';
import { LineMapperService } from '../../../../core/components/charts/line/services/line.mapper.service';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "apollo-angular";
import * as i3 from "../../../../core/components/charts/line/services/line.mapper.service";
var VolumetryService = /** @class */ (function () {
    function VolumetryService(translate, apollo, mapper) {
        this.translate = translate;
        this.apollo = apollo;
        this.mapper = mapper;
    }
    VolumetryService.prototype.positionByPeriod = function (period) {
        var map = {
            'up_to_2_days': 0,
            'between_3_and_6_days': 1,
            'between_7_and_15_days': 2,
            'more_than_15_days': 3,
        };
        return map[period];
    };
    VolumetryService.prototype.accountMaintenancesSegments = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesSegments ($where: DashboardInput!) {\n        accountMaintenancesSegments(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesSegments ($where: DashboardInput!) {\n        accountMaintenancesSegments(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        fetchPolicy: 'cache-first',
                        query: query,
                        variables: { where: where },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return chain(data.accountMaintenancesSegments.items)
                            .orderBy('value')
                            .reverse()
                            .value();
                    })];
            });
        });
    };
    VolumetryService.prototype.accountMaintenancesTypes = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesTypes ($where: DashboardInput!) {\n        accountMaintenancesTypes(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesTypes ($where: DashboardInput!) {\n        accountMaintenancesTypes(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        fetchPolicy: 'cache-first',
                        query: query,
                        variables: { where: where },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return chain(data.accountMaintenancesTypes.items)
                            .orderBy('value')
                            .reverse()
                            .value();
                    })];
            });
        });
    };
    VolumetryService.prototype.autofillChartDataGaps = function (inputChartData) {
        var momentsInterval = [
            'up_to_2_days',
            'between_3_and_6_days',
            'between_7_and_15_days',
            'more_than_15_days'
        ];
        var chartDataInput = inputChartData.accountMaintenancesPendingTimeInterval.items;
        if (chartDataInput.length < 4) {
            for (var index = 0; index < 4; index++) {
                chartDataInput.push({ name: momentsInterval[index], value: 0, extra: null });
            }
        }
        return chartDataInput;
    };
    VolumetryService.prototype.accountMaintenancesPendingTimeInterval = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesPendingTimeInterval ($where: DashboardInput!) {\n        accountMaintenancesPendingTimeInterval(where: $where) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesPendingTimeInterval ($where: DashboardInput!) {\n        accountMaintenancesPendingTimeInterval(where: $where) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        fetchPolicy: 'cache-first',
                        query: query,
                        variables: { where: where },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        var processedChartData = _this.autofillChartDataGaps(data);
                        return chain(processedChartData)
                            .cloneDeep()
                            .orderBy(function (item) { return _this.positionByPeriod(item.name); })
                            .map(function (value) {
                            var key = ("VOLUMETRY.CHART.OPEN_MAINTENANCE_PER_PERIOD." + value.name).toUpperCase();
                            value.name = _this.translate.instant(key);
                            return value;
                        })
                            .value();
                    })];
            });
        });
    };
    VolumetryService.prototype.accountMaintenancesTopPendingTime = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesTopPendingTime ($where: DashboardInput!) {\n        accountMaintenancesTopPendingTime(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesTopPendingTime ($where: DashboardInput!) {\n        accountMaintenancesTopPendingTime(where: $where, limit: 10) {\n          reportName\n          items {\n            name: key\n            value\n            extra\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        fetchPolicy: 'cache-first',
                        query: query,
                        variables: { where: where },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return chain(data.accountMaintenancesTopPendingTime.items)
                            .cloneDeep()
                            .orderBy('value')
                            .reverse()
                            .map(function (item) {
                            item.extra.location = { name: item.name };
                            item.name = item.name + " \u2022 " + item.extra.maintenance.number;
                            return item;
                        })
                            .value();
                    })];
            });
        });
    };
    VolumetryService.prototype.accountMaintenancesCompletedBySources = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n        query accountMaintenancesCompletedBySources($where: DashboardInput!) {\n          accountMaintenancesCompletedBySources(where: $where) {\n            reportName\n            items {\n              name: key\n              value\n            }\n          }\n        }\n    "], ["\n        query accountMaintenancesCompletedBySources($where: DashboardInput!) {\n          accountMaintenancesCompletedBySources(where: $where) {\n            reportName\n            items {\n              name: key\n              value\n            }\n          }\n        }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        fetchPolicy: 'cache-first',
                        query: query,
                        variables: { where: where },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        var map = {
                            'orc': 'App do colaborador',
                            'gothmog': 'App do gestor',
                            'mordor': 'Painel do gestor',
                            'carchost': 'API'
                        };
                        return chain(data.accountMaintenancesCompletedBySources.items)
                            .cloneDeep()
                            .map(function (item) {
                            item.name = map[item.name] || item.name;
                            return item;
                        })
                            .value();
                    })];
            });
        });
    };
    VolumetryService.prototype.accountMaintenancesCompletedTimeline = function (interval, where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                delete where.from;
                delete where.to;
                query = gql(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesCompletedTimeline($where: DashboardMaintenancesTimelineWhereInput!) {\n        accountMaintenancesCompletedTimeline(where: $where) {\n          reportName\n          items {\n            closedAt\n            totalCount\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesCompletedTimeline($where: DashboardMaintenancesTimelineWhereInput!) {\n        accountMaintenancesCompletedTimeline(where: $where) {\n          reportName\n          items {\n            closedAt\n            totalCount\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        fetchPolicy: 'cache-first',
                        query: query,
                        variables: {
                            where: tslib_1.__assign({}, where, { interval: interval })
                        },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        var mappedData = chain(data.accountMaintenancesCompletedTimeline.items)
                            .cloneDeep()
                            .map(function (item) {
                            item['completedAt'] = item['closedAt'];
                            delete item.closedAt;
                            return item;
                        })
                            .value();
                        return _this.mapper.toLineChartFormat(mappedData, interval);
                    })];
            });
        });
    };
    VolumetryService.prototype.accountMaintenancesCompletedLineChart = function (where) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = gql(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n      query accountMaintenancesCompletedLineChart($where: DashboardMaintenancesLineChartWhereInput!) {\n        accountMaintenancesCompletedLineChart(where: $where) {\n          reportName\n          items {\n            date: closedAt\n            totalCount\n          }\n        }\n      }\n    "], ["\n      query accountMaintenancesCompletedLineChart($where: DashboardMaintenancesLineChartWhereInput!) {\n        accountMaintenancesCompletedLineChart(where: $where) {\n          reportName\n          items {\n            date: closedAt\n            totalCount\n          }\n        }\n      }\n    "])));
                return [2 /*return*/, this.apollo
                        .query({
                        fetchPolicy: 'cache-first',
                        query: query,
                        variables: {
                            where: tslib_1.__assign({}, where, { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }),
                        },
                    })
                        .toPromise()
                        .then(function (_a) {
                        var data = _a.data;
                        return data.accountMaintenancesCompletedLineChart;
                    })];
            });
        });
    };
    VolumetryService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VolumetryService_Factory() { return new VolumetryService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.Apollo), i0.ɵɵinject(i3.LineMapperService)); }, token: VolumetryService, providedIn: "root" });
    return VolumetryService;
}());
export { VolumetryService };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
